import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import AuthReducer from './AuthReducer/AuthReducer';
import EmployeeRewardsReducer from './EmployeeRewardsReducer/EmployeeRewardsReducer';
import AdminReducer from './AdminReducer/AdminReducer';
import history from '../../Router/History';
import TenantReducer from './TenantReducer';

const appReducer = combineReducers({
  router: connectRouter(history),
  auth: AuthReducer,
  employeeRewards: EmployeeRewardsReducer,
  tenant: TenantReducer,
  admin: AdminReducer
});

const RootReducer = (state, action) => {
  return appReducer(state, action);
};

export default RootReducer;
